import * as React from 'react';

import HeaderUI from './HeaderUI';
import FooterUI from './FooterUI';

class LayoutUI extends React.Component<{}, {}> {
    public render() {
        return (
            <div>
                <HeaderUI />
                {this.props.children}
                <FooterUI />
            </div>
        );
    }
}

export default LayoutUI;